


























































































































































































import NextButton from '@/components/shared/NextButton'
import PreviousButton from '@/components/shared/PreviousButton'
import CancelButton from '@/components/shared/CancelButton'
import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import { Pallet, Box, ProgramSettings, RobotTypeEnum } from '@/model'
import Units from '@/api/utils/units'
import { defaultPallet, defaultPalletTypes, robots } from '@/api/const'

@Component({
  components: {
    NextButton: NextButton,
    PreviousButton: PreviousButton,
    CancelButton: CancelButton
  }
})
export default class SimpleFormD extends Vue {
  @Prop({ default: defaultPallet }) private value!: Pallet
  @Prop() private box!: Box
  @Prop({ required: true }) private programSettings!: ProgramSettings
  @Prop({ required: true }) private parentBus!: Vue
  @Prop({ required: true }) private units!: Units
  @Prop({ required: true }) private patternHasBoxPositions!: boolean

  private localOverhangL: number = 0
  private localOverhangT: number = 0
  private localOverhangR: number = 0
  private localOverhangB: number = 0

  private localWidth: number = defaultPallet.width!
  private localLength: number = defaultPallet.length!
  private localHeight: number = defaultPallet.height!
  private localApproachAngle: number = 45
  private localApproachDistance: number = 0
  private minPalletDimension: number = this.units.toLocalLength(500)!
  private maxPalletDimension: number = this.units.toLocalLength(1300)!
  private minPalletHeight: number = this.units.toLocalLength(140)!
  private maxPalletHeight: number = this.units.toLocalLength(170)!

  private active: boolean = false
  private toggle: boolean = false
  private pallet: Pallet = JSON.parse(JSON.stringify(this.value))  // ultra deep deep copy
  private valid: boolean = false
  // pallet type and overhang fields shall not be editable if there are layer patterns with box positions
  private palletTypeAndOverhangReadOnly: boolean = this.patternHasBoxPositions

  private rules: object = {
    required: (v: any) => !!v || this.localText('general.required'),
    min: (v: any) => ((!v) || (v >= 0)) || this.localText('general.largerEqualZero'),
    minPalletDimension: (v: any) => ((!v) || (v >= this.minPalletDimension)) || `${this.localText('general.atleast')} ${this.minPalletDimension}`,
    maxPalletDimension: (v: any) => ((!v) || (v <= this.maxPalletDimension)) || `${this.localText('general.valueMax')} ${this.maxPalletDimension}`,
    minPalletHeight: (v: any) => ((!v) || (v >= this.minPalletHeight)) || `${this.localText('general.atleast')} ${this.minPalletHeight}`,
    maxPalletHeight: (v: any) => ((!v) || (v <= this.maxPalletHeight)) || `${this.localText('general.maximumPal')} ${this.maxPalletHeight}`,
    approachAngle: (v: any) => (v === 0 || (v && v >= -360 && v <= 360)) || this.localText('robotStep.angleLimit'),
    approachDistance: (v: any) => (v === 0 || (v && v >= 0)) || this.localText('general.largerEqualZero')
  }

  private palletHeightExceeded: boolean = false
  private selectedPalletIndex: number = 0
  private activePattern: number = 0

  private palletTypes: Pallet[] = [defaultPalletTypes[0]] // only EUR by default
  private showAdvanced: boolean = false
  private showCustom: boolean = this.pallet.palletType === 'CUSTOM'

  // Watcher to emit valid state to "next" button in stepper
  @Watch('valid')
  private validWatcher (value: boolean) {
    this.$emit('validate', value)
  }

  private mounted () {
    this.initPalletTypes()
    this.initPallet(this.pallet)

    this.parentBus.$on('stepper_next', this.next)
    this.parentBus.$on('stepper_previous', this.previous)

    const enc = this.units.toLocalLength
    this.localOverhangL = enc(this.pallet.overhangL) || 0
    this.localOverhangT = enc(this.pallet.overhangT) || 0
    this.localOverhangR = enc(this.pallet.overhangR) || 0
    this.localOverhangB = enc(this.pallet.overhangB) || 0
    this.localHeight = enc(this.pallet.height) || 145
    this.localApproachAngle = this.defaultApproachAngle()
    this.localApproachDistance = this.defaultApproachDistance()

    if (this.units.isImperial) {
      // set by default minimum overhang in INCHES
      // to compensate calculation error for imperial units.
      // Every box sized in inches has 0..1 mm error in size after converting to mm.
      const minimum = 0.2
      if (this.localOverhangR < minimum) {
        this.localOverhangR = minimum
      }
      if (this.localOverhangB < minimum) {
        this.localOverhangB = minimum
      }
    }

  }

  private initPalletTypes () {
    const robot = robots.find(p => p.id === this.programSettings.robotType)
    if (robot) {
      this.palletTypes = defaultPalletTypes.filter(t => robot.pallets.includes(t.palletType!))
    }
  }

  private updateOverhangValues () {
    const dec = this.units.toSystemLength
    this.pallet.overhangL = dec(this.localOverhangL)
    this.pallet.overhangT = dec(this.localOverhangT)
    this.pallet.overhangR = dec(this.localOverhangR)
    this.pallet.overhangB = dec(this.localOverhangB)

    this.pallet.length = dec(this.localLength)
    this.pallet.width = dec(this.localWidth)
    this.pallet.height = dec(this.localHeight)
    if (this.isCustomSolution()) {
      this.programSettings.approachAngle = Math.floor(Number(this.localApproachAngle))
      this.programSettings.approachDistance = Math.floor(Number(this.localApproachDistance))
    }
  }

  private beforeDestroy () {
    this.parentBus.$off('stepper_next', this.next)
    this.parentBus.$off('stepper_previous', this.previous)
  }

  private next () {
    this.updateOverhangValues()
    this.$emit('next', this.pallet)
  }

  private previous () {
    this.$emit('previous')
  }

  private setPalletType (palletType: string | undefined) {
    if (!this.palletTypeAndOverhangReadOnly) {
      const index = this.palletTypes.findIndex(p => p.palletType === palletType)
      this.selectedPalletIndex = (index >= 0) ? index : 0
      const pallet = this.palletTypes[this.selectedPalletIndex]
      this.pallet.palletType = pallet.palletType

      this.setPalletDimensions(pallet)
    }
  }

  private initPallet (palletArg: Pallet) {
    const index = this.palletTypes.findIndex(p => p.palletType === palletArg.palletType)
    this.selectedPalletIndex = (index >= 0) ? index : 0
    const pallet = this.palletTypes[this.selectedPalletIndex]
    this.pallet.palletType = pallet.palletType

    this.setPalletDimensions(palletArg)
  }

  private setPalletDimensions (palletArg: Pallet) {
    const enc = this.units.toLocalLength
    this.localLength = enc(palletArg.length) || defaultPallet.length!
    this.localWidth = enc(palletArg.width) || defaultPallet.width!
    this.localHeight = enc(palletArg.height) || defaultPallet.height!

    this.showCustom = palletArg.palletType === 'CUSTOM'
  }

  private localText (b: string): string {
    return String(this.$t(b))
  }

  private defaultApproachAngle (): number {
    const angle = this.programSettings.approachAngle
    return angle === 0 || angle ? Number(angle) : 45
  }

  private defaultApproachDistance (): number {
    const distance = this.programSettings.approachDistance
    return distance === 0 || distance ? Number(distance) : 200
  }

  private isCustomSolution () {
    return RobotTypeEnum.CUSTOM_SOLUTION === this.programSettings.robotType
  }

  private translateUnit (unit: string): string {
    return String(this.$t('general.' + unit))
  }

  }
